jQuery(document).ready(function ($) {
  $('.wp-block-cb-carousel-v2.heat-index').each(function () {
    const $block = $(this);
    const $swiperContainer = $block.find('.swiper').get(0);
    if (!$swiperContainer) return;


    // Destroy existing Swiper instance if present
    const existingSwiper = $swiperContainer.swiper;
    if (existingSwiper) existingSwiper.destroy(true, false);

    const nextEl = $block.find('.cb-button-next.swiper-button-next').get(0) || null;
    const prevEl = $block.find('.cb-button-prev.swiper-button-prev').get(0) || null;

    let $pagination = $block.find('.swiper-pagination');
    if (!$pagination.length) { 
      $pagination = $('<div class="swiper-pagination"></div>').appendTo($block);
    }
    const paginationEl = $pagination.get(0);

    // Initialize Swiper with fade effect
    const swiper = new Swiper($swiperContainer, { 
      effect: 'fade',
      fadeEffect: { crossFade: true },
      speed: 600,
      loop: true,
      navigation: { nextEl, prevEl },
      pagination: { el: paginationEl, clickable: true },
      allowTouchMove: false,
    });

    // Optional: fade in the block container itself
    $block.removeClass('slide-in-from-right animate-in').addClass('fade-in');

    // Update gradient on slide change
    swiper.on('slideChange', function () {
      setTimeout(function () {
        updateRadialGradient(swiper.realIndex, $block);
      }, 200); // slightly after fade completes
    });

    // Initial gradient on load
    setTimeout(function () {
      updateRadialGradient(swiper.realIndex, $block);
    }, 200);

    // Update gradient when user clicks nav buttons or bullets
    $block.on('click', '.cb-button-next, .cb-button-prev, .swiper-pagination-bullet', function () {
      setTimeout(function () {
        updateRadialGradient(swiper.realIndex, $block);
      }, 250); // sync slightly after fade
    });
  });

  // Gradient update function
  function updateRadialGradient(index, $scope) {
      const classIndex = (typeof index === 'number') ? (index + 1) : 1;
      const prefix = 'slide-';
      let $radial;
      if ($scope && $scope.length && $scope.find('.radial-gradient').length) {
        $radial = $scope.find('.radial-gradient');
      } else {
        $radial = $('.radial-gradient');
      }
      $radial.removeClass(function (i, className) {
        return (className.match(new RegExp('\\b' + prefix + '\\d+\\b', 'g')) || []).join(' ');
      });
      $radial.addClass(prefix + classIndex);
    }
});